module.exports = __webpack_public_path__ + "media/images/logo_listsothebysrealty-e4b558c2a3ef9a8fb4dc5e1ed9ac9651.png";